import { useEffect, useState } from "react";
import ReactConfetti from 'react-confetti';

interface PrizeAnimationProps {
  showConfetti: boolean;
  windowSize: { width: number; height: number };
}

export function PrizeAnimation({ showConfetti, windowSize }: PrizeAnimationProps) {
  if (!showConfetti) return null;
  
  return (
    <ReactConfetti
      width={windowSize.width}
      height={windowSize.height}
      recycle={false}
      numberOfPieces={2000}
      gravity={0.15}
      wind={0.0}
      colors={['#FFD700', '#DAA520', '#FFC125', '#E5B73B']}
      confettiSource={{ x: windowSize.width / 2, y: -150, w: 10, h: 100 }}
      initialVelocityX={15}
      initialVelocityY={50}
      tweenDuration={10000}
      drawShape={(ctx) => {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(69, 0);
        ctx.lineTo(70, 20);
        ctx.lineTo(0, 16);
        ctx.closePath();
        ctx.fill();
      }}
    />
  );
}